"use client";

import { useEffect } from "react";

import { useAuthStore } from "@/auth/authStore";

import { OnboardingManager } from "./OnboardingManager";
import { OnboardingModal } from "./OnboardingModal";
import { useOnboardingStore } from "./onboardingStore";

export const AuthOnboardingRoot = () => {
  const activationStatus = useAuthStore((state) => state.activationStatus);
  const authority = useAuthStore((state) => state.authority);
  const status = useAuthStore((state) => state.status);
  const isModalOpen = useOnboardingStore((state) => state.isModalOpen);
  const startWithAccessCodeEntry = useOnboardingStore(
    (state) => state.startWithAccessCodeEntry
  );

  useEffect(() => {
    if (
      status !== "authenticated" ||
      authority === null ||
      activationStatus !== "notActivated" ||
      isModalOpen ||
      useOnboardingStore.getState().wasDismissed(authority)
    ) {
      return;
    }

    startWithAccessCodeEntry(authority);
  }, [
    activationStatus,
    authority,
    isModalOpen,
    startWithAccessCodeEntry,
    status,
  ]);

  return (
    <>
      <OnboardingManager />
      <OnboardingModal />
    </>
  );
};
